import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { MapComponent } from './map/map.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Cluster } from './shared/Cluster.service';
import { Cut } from './shared/Cut.pipe';
import { NgApexchartsModule } from 'ng-apexcharts';
import { Value } from './shared/Value.pipe';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpRequest } from './shared/HttpRequest.service';
import { HttpInterceptor } from './shared/HttpInterceptor.service';
import { ApiKeyInterceptor } from './shared/api-key.interceptor';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    SidebarComponent,
    MapComponent,
    Cut,
    Value
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    NgbModule,
    NgApexchartsModule,
    BrowserAnimationsModule
  ],
  providers: [
    Cluster,
    HttpRequest,
    { provide: HTTP_INTERCEPTORS, useClass: ApiKeyInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
